import { useCallback, useRef, useState } from 'react'

export const useReauthentication = () => {
  const [reauthModalOpen, setReauthModalOpen] = useState(false)
  const isReauthenticating = useRef(false)
  const reauthPromise = useRef<Promise<void> | null>(null)
  const reauthResolveRef = useRef<(() => void) | null>(null)
  const reauthRejectRef = useRef<((reason: Error) => void) | null>(null)

  const requestReauthentication = useCallback((): Promise<void> => {
    if (!isReauthenticating.current) {
      isReauthenticating.current = true
      reauthPromise.current = new Promise<void>((resolve, reject) => {
        reauthResolveRef.current = resolve
        reauthRejectRef.current = reject
        setReauthModalOpen(true)
      })
    }

    return reauthPromise.current!
  }, [])

  const handleReauthSuccess = useCallback(() => {
    setReauthModalOpen(false)
    isReauthenticating.current = false
    reauthResolveRef.current?.()
    reauthResolveRef.current = null
    reauthRejectRef.current = null
    reauthPromise.current = null
  }, [])

  const handleReauthCancel = useCallback(() => {
    setReauthModalOpen(false)
    isReauthenticating.current = false
    reauthRejectRef.current?.(new Error('Reauthentication cancelled'))
    reauthResolveRef.current = null
    reauthRejectRef.current = null
    reauthPromise.current = null
  }, [])

  return {
    reauthModalOpen,
    requestReauthentication,
    handleReauthSuccess,
    handleReauthCancel
  }
}
